import styled from 'styled-components';

const StyledCloudChartWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export { StyledCloudChartWrapper };
